export type VolunteerStateValues = 'ONGOING' | 'FINISHED' | 'OTHER';

export const volunteerStates: VolunteerStateValues[] = [
  'FINISHED',
  'ONGOING',
  'OTHER',
];

enum VOLUNTEER_STATES {
  ONGOING = 'Je suis encore en volontariat (Service Civique, VSI, Corps européen de solidarité)',
  FINISHED = "J'ai terminé mon volontariat (Service Civique, VSI, Corps européen de solidarité)",
  OTHER = "Je suis (ou j'étais) en bénévolat",
}
export default VOLUNTEER_STATES;
